<div id="findbarOptionsThreeContainer">
  <pdf-find-ignore-accents></pdf-find-ignore-accents>
  <pdf-find-fuzzily></pdf-find-fuzzily>
  <pdf-find-results-count></pdf-find-results-count>
</div>
